import React from "react";
import MyDistribuitionComponent from "../../../components/myDistribuitionComponent";
import EarningsChartComponent from "../../../components/EarningsChartComponent/EarningsChartComponent";
function TotalDashboard(props){
    return(
        <div>
            <MyDistribuitionComponent ativos={props.ativos}/>
            <br/>
            <div className="columns">
                <div className="column is-12">
                    {/* ✅ Earnings Chart */}
                    <EarningsChartComponent/>
                </div>
            </div>
        </div>
    )
}

export default TotalDashboard;
